<template>
  <ToolbarGroup>
    <a class="btn" href="" v-on:click.prevent="doArchive">
      <i class="fa-solid fa-box-archive" v-if="!item.archived"></i>
      <i class="fa-solid fa-rotate-left" v-else></i>
    </a>
  </ToolbarGroup>
</template>

<script>
import api from '@/Util/api';

export default {
  props: ["item"],
  methods: {
    doArchive() {
      if (this.item.archived) {
        this.item.archived=null;
      } else {
        this.item.archived=1;
      }
      if (this.item.save)
        this.item.save("{archived}");
      else if (this.item.id)
        api.doUpdate('Product', this.item.id, {archived: this.item.archived});
    },

  },
}
</script>
